import React from 'react';
import {Dialog, IconButton, DialogTitle, DialogContent, CircularProgress, Box} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface openPopupProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    paymentParams: any;
    onClose: () => void;
}

const PaymentPopup = (props: openPopupProps): React.JSX.Element => {
    const {open, setOpen, paymentParams, onClose} = props;

    const handlerClose = () => {
        setOpen(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handlerClose} fullWidth maxWidth="md">
            <DialogTitle sx={{pr: 5}}>Оплата</DialogTitle>
            <IconButton onClick={handlerClose} style={{position: 'absolute', right: 16, top: 16}}>
                <CloseIcon />
            </IconButton>

            <DialogContent
                sx={{
                    minHeight: '950px',
                    position: 'relative',
                    padding: 0,
                }}
            >
                {!paymentParams?.paySrc && !paymentParams?.error ? (
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            minHeight: '950px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CircularProgress size={60} thickness={5} />
                    </Box>
                ) : paymentParams?.error ? (
                    <p style={{padding: '25px'}}>{paymentParams?.error}</p>
                ) : (
                    <iframe
                        id="payIFrame"
                        src={paymentParams.paySrc}
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            minHeight: '100%',
                            border: 'none',
                        }}
                        allowFullScreen
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default PaymentPopup;
